import type { TrainingItemDetailsVM } from "@shared-kernel/application/ports/student/student-repository";
import type { TRAINING_ITEM_TYPE } from "@academy-context/shared/domain/types/training-items";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

interface RetrieveTrainingItemDetailsParams {
  id: string;
  type: TRAINING_ITEM_TYPE;
}

export const studentRetrieveTrainingItemDetails = createApiThunk<TrainingItemDetailsVM, RetrieveTrainingItemDetailsParams>(
  "trainingItemDetails/studentRetrieveTrainingItemDetails",
  async ({ id, type }, { extra: { studentRepository } }) => {
    return studentRepository!.getTrainingItemById(id, type);
  },
);
